<template lang="html">
  <div class="block__content">
    <h2>{{$t('title')}}</h2>
    <template v-if="isInit">
      <div class="text-center loader-wrapper">
        <circle-loader></circle-loader>
      </div>
    </template>
    <template v-else>
      <profile-update-required-crypto-notice :cryptoaddress-available="cryptoaddressAvailable">
        <div>
          <ul class="tarnsfer_form">
            <li>
              <div class="form-step">
                <h2>{{$t('title_1')}}</h2>
                <form class="form" @submit.prevent.stop>
                  <payout-form-group :label="$t('Получатель')" :required="true">
                    <div style="width:370px">
                      <prime-dropdown-accounts :disabled="formDisabled" :accounts="filteredAccounts" v-model="model.values.account"></prime-dropdown-accounts>
                      <error-message-block v-slot:errors attribute="account" :errors="model.errors"></error-message-block>
                    </div>
                  </payout-form-group>
                </form>
              </div>
            </li>
            <li>
              <div class="form-step">
                <h2>{{$t('title_2')}}</h2>
                <form class="form" @submit.prevent.stop>
                  <payout-form-group :label="$t('Адрес')" :required="true">
                    <!-- div(style="width:370px")-->
                    <dropdown-crypto-addresses
                      style="width:370px"
                      :addresses="model.addresses" v-model="model.selectedAddress" @update="onAddressSelected" :disabled="formDisabled"></dropdown-crypto-addresses>
                  </payout-form-group>
                  <payout-hint-panel-form-group>
                    <template>{{$t('address_hint')}}</template>
                  </payout-hint-panel-form-group>
                  <template v-if="model.selectedAddress">
                    <payout-form-group :label="$t('Адрес')" :required="true">
                      <input class="form-control" type="text" :readonly="true" :value="selectedChecksumAddress"/>
                    </payout-form-group>
                    <div class="text-center"><br/><br/>
                      <div class="qrcode-wrapper">
                        <qrcode-styling :qrcode-styling-config="qrcodeConfig" :source-data="selectedChecksumAddress"></qrcode-styling>
                      </div>
                    </div>
                  </template>
                </form>
                <!-- .text-centerbutton(:disabled="formDisabled" @click.prevent="submit").btn.btn-success {{$t('Перейти к оплате')}}
                -->
              </div>
            </li>
          </ul>
        </div>
      </profile-update-required-crypto-notice>
    </template>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import {Component} from "vue-property-decorator";
import DropdownCryptoAddresses from "@/components/forms/dropdown/DropdownCryptoAddresses.vue";
import PayoutFormGroup from "@/components/forms/payout/PayoutFormGroup.vue";
import PayoutHintPanelFormGroup from "@/components/forms/payout/hint/PayoutHintPanelFormGroup.vue";
import ErrorMessageBlock from "@/components/forms/payout/ErrorMessageBlock.vue";
import PayoutInputHintBlock from "@/components/forms/payout/PayoutInputHintBlock.vue";
import {MoneyFormatFilter} from "@/models/filters/money";
import CircleLoader from "@/components/loaders/CircleLoader.vue";
import ProfileUpdateRequiredCryptoNotice
  from "@/views/pages/finance/accounts/crypto/notice/ProfileUpdateRequiredCryptoNotice.vue";
import {DepositUsdcTransferModel} from "@/views/pages/finance/deposit/usdc/deposit-usdc";
import QrcodeStyling from "@/components/other/QrcodeStyling.vue";
import {ethereumToChecksumAddress} from "@/core/crypto/ethereum";
import PrimeDropdownAccounts from "@/components/forms/dropdown/PrimeDropdownAccounts.vue";

@Component({
  name: "DepositUsdcTransferPage",
  filters: {
    money: MoneyFormatFilter,
    toChecksumAddress: (address: string) => {
      return ethereumToChecksumAddress(address);
    }
  },
  components: {
    PrimeDropdownAccounts,
    QrcodeStyling,
    ProfileUpdateRequiredCryptoNotice,
    CircleLoader,
    PayoutInputHintBlock,
    ErrorMessageBlock,
    PayoutHintPanelFormGroup,
    PayoutFormGroup,
    DropdownCryptoAddresses
  }
})
export default class DepositUsdcTransferPage extends Vue {
  model = new DepositUsdcTransferModel()

  onAddressSelected(address) {
    this.model.values.address = address ? address.address : '';
  }

  get isInit() {
    return this.model.initStatus.isLoading
  }

  get selectedChecksumAddress() {
    return this.model.values.address ? ethereumToChecksumAddress(this.model.values.address) : '';
  }

  mounted() {
   this.reloadModel()
  }

  get cryptoaddressAvailable() {
    return this.model.initStatus.isLoaded && this.model.options.avail
  }

  reloadModel() {
    this.model.loadModel().catch(err => {
      this.model.initStatus.loadStart()
      setTimeout(() => {
        this.reloadModel()
      }, 3000)
    })
  }

  get formDisabled() {
    return this.model.initStatus.isLoading
  }

  get filteredAccounts() {
    return this.model.accounts
  }

  get qrcodeConfig() {
    return {
      width: 250,
      height: 250,
      type: "svg",
      margin: 0,
      //data: "https://www.facebook.com/",
      // image: 'data:image/svg+xml;base64,' + CapLogoImage.logoWorking, //"https://upload.wikimedia.org/wikipedia/commons/5/51/Facebook_f_logo_%282019%29.svg",
      dotsOptions: {
        color: "#627f23", //93bb36
        type: "square"
      },
      backgroundOptions: {
        color: "#ffffff",
      },
      cornersSquareOptions: {
        "type": "extra-rounded",
        //"color": "#000000"
      },
      imageOptions: {
        hideBackgroundDots: true,
        crossOrigin: "anonymous",
        imageSize: 0.5,
        margin: 0
      },
      qrOptions: {typeNumber: "10", mode: "Byte", errorCorrectionLevel: "H"}
    }
  }
}
</script>

<style scoped lang="less">
.loader-wrapper {
  display: flex;
  justify-content: center;
  margin: 3em 0 1em 0;
}

.qrcode-wrapper {
  width:300px; margin: 0 auto;
}
</style>

<i18n>
{
  "en": {
    "title": "Deposit USDC (ERC20) account via direct transfer",
    "title_1": "Account for replenishment",
    "title_2": "Address for transfer",
    "Адрес": "Address",
    "address_hint": "You can choose any of yours address, it will be used for the deposit transaction.",
    "Перейти к оплате": "Proceed to payment",
    "Сумма": "Amount",
    "Получатель": "Beneficiary account",
    "amount_hint": "Amount from {min} to {max} {cur}. The amount must be whole.",
    "Получаете": "Result amount",
    "result_amount_hint": "Your account will be replenished with this amount."
  },
  "ru": {
    "result_amount_hint": "Эту сумму вы получите на счет.",
    "title": "Пополнение USDC (ERC20) счета прямым переводом",
    "title_1": "Cчет для пополнения",
    "title_2": "Адрес для перевода",
    "address_hint": "Можете выбрать любой из ваших адресов, он будет использоваться для транзакции пополнения.",
    "amount_hint": "Сумма от {min} до {max} {cur}. Сумма должна быть целой без копеек."
  }
}
</i18n>
